const ROUTE_ROOT_URL = "/api";
 
const ApiRoutes = {
    AUTH: {
        ROOT_CONTEXT: `${ROUTE_ROOT_URL}/auth`,
        LOGIN: `/login`,
        UPDATE_PASSWORD: `/update-password`,
        RESET_PASSWORD: `/reset-password`,
        PUBLIC_KEY: `/public-key`,
    },
    VENDORS: {
        ROOT_CONTEXT: `${ROUTE_ROOT_URL}/vendors`,
        DASHBOARD: `/dashboard`,
    },
    EMPLOYEE: {
        ROOT_CONTEXT: `${ROUTE_ROOT_URL}/employee`,
        TRANSACTIONS: `/transactions`,
        ITEMS: `/items`,
        LOCATIONS: '/locations',
        BUY_ITEMS: `/buy`,
        CURRENT_LOCATION_ID: 'currentLocationId',
        GET_EVENT_UPDATES: `/event-details`
    }
};
 
export default ApiRoutes;